import React from 'react'
import Logo from "/assets/images/swayamRiskLogoBlue.png";
import style from "./CareerOption.module.css";
import Bg from "/assets/PdfNew/pgbg10.png";
const CareerOption = () => {
    return (
        <div className={style.careerOptionBg}>
            {/* Background */}
            <img src={Bg} alt="background" className={style.careerOptionBg} />

            {/* Logo */}
            <img src={Logo} alt="logo" className={style.logo} />


            {/* Content */}
            <div className={style.content}>
                <p className={style.title}>
                    <strong>Career Options</strong>
                </p>
                <br></br>


                <p   >
                

You have done the hard part — now comes the exciting part. Based on everything we have learned about you, here are the career paths where your strengths, personality and interests come together most powerfully. These are not random suggestions. Each one has been matched to who you genuinely are — so explore them with an open mind and let yourself imagine the possibilities.</p>

            </div>

        </div>
        )
}

export default CareerOption